import { getAllowPayments } from "./api";

export const convertToDollars = (cents) => (cents / 100).toFixed(2);

export const getTimeInSeconds = (date) => Math.floor(date.getTime() / 1000);

export const getRangeForFilters = (value, dataRange) => {
    switch (value) {
        case "today":
            const today = new Date();
            dataRange.start = getTimeInSeconds(new Date(today.setHours(0, 0, 0, 0)));
            dataRange.end = getTimeInSeconds(new Date(today.setHours(23, 59, 59, 999)));

            break;
        case "thisWeek":
            const currentDate = new Date();
            const firstDayOfWeek = currentDate.getDate() - currentDate.getDay();
            const lastDayOfWeek = firstDayOfWeek + 6;

            dataRange.start = new Date(currentDate.setDate(firstDayOfWeek));
            dataRange.start.setHours(0, 0, 0, 0);
            dataRange.start = getTimeInSeconds(dataRange.start);

            dataRange.end = new Date(currentDate.setDate(lastDayOfWeek));
            dataRange.end.setHours(23, 59, 59, 999);
            dataRange.end = getTimeInSeconds(dataRange.end);

            break;
        case "last7Days":
            const endDate7 = new Date();
            const startDate7 = new Date();

            startDate7.setDate(endDate7.getDate() - 6);

            dataRange.start = getTimeInSeconds(new Date(startDate7.setHours(0, 0, 0, 0)));
            dataRange.end = getTimeInSeconds(new Date(endDate7.setHours(23, 59, 59, 999)));

            break;
        case "thisMonth":
            const now = new Date();

            dataRange.start = getTimeInSeconds(new Date(now.getFullYear(), now.getMonth(), 1));
            dataRange.end = getTimeInSeconds(new Date(now.getFullYear(), now.getMonth() + 1, 0));

            break;
        case "last30Days":
            const endDate30 = new Date();
            const startDate30 = new Date();

            startDate30.setDate(endDate30.getDate() - 29);
            dataRange.start = getTimeInSeconds(new Date(startDate30.setHours(0, 0, 0, 0)));
            dataRange.end = getTimeInSeconds(new Date(endDate30.setHours(23, 59, 59, 999)));

            break;
        case "allTime":
            dataRange.start = null;
            dataRange.end = null;

            break;
        case "custom":
            return dataRange;
        default:
            dataRange.start = null;
            dataRange.end = null;

            break;
    }

    return dataRange;
};

/**
 * Calls GET /payments/allow-payments and returns whether credit purchases are enabled
 * for the current user. Defaults to false on any error / unexpected response.
 */
export const checkAllowPayments = async () => {
    try {
        const response = await getAllowPayments();
        if (response?.isAxiosError || response?.response) {
            return false;
        }
        return Boolean(response?.data?.allowPayments);
    } catch (error) {
        console.error("Error checking allow-payments:", error);
        return false;
    }
};
